
<script context="module">

import { 
  VmYoutube,
  VmEmbed 
} from '@vime/core';

import { define } from '../lib';
  

define('vm-youtube', VmYoutube);
define('vm-embed', VmEmbed);
  
</script>

<script>
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';

let __ref;
let __mounted = false;

const dispatch = createEventDispatcher();

let className = '';

export let style = '';
export { className as class };

export let cookies = false;
export let videoId;
export let showFullscreenControl = true;
export let poster = undefined;
export let language = 'en';
export let autoplay = false;
export let controls = false;
export let logger = undefined;
export let loop = false;
export let muted = false;
export let playsinline = false;
export const getAdapter = (...args) => __ref.getAdapter(...args);
export const ref = () => __ref;
export const getWebComponent = () => __ref;

onMount(() => {
  

  __mounted = true;
});

$: if (__mounted) setProp(__ref, 'logger', logger);

const onEvent = (e) => {
  e.stopPropagation();
  dispatch(e.type, e.detail);
};
</script>

<vm-youtube
  class={className}
  style={style}
  cookies={cookies}
  video-id={videoId}
  show-fullscreen-control={showFullscreenControl}
  poster={poster}
  language={language}
  autoplay={autoplay}
  controls={controls}
  loop={loop}
  muted={muted}
  playsinline={playsinline}
  on:vmLoadStart={onEvent}
  bind:this={__ref}
>
  <slot></slot>
</vm-youtube>
  